import capitalize from 'lodash-es/capitalize'
import { useRouter } from 'next/router'
import { stringifyUrl } from 'query-string'
import { useMemo } from 'react'

import { FILTERS_QUERY_PARAM, LegacyFilterQueryParam } from '../../../../../brunswick/constants'
import { canonicalBaseUrls } from '../../../../../constants/figs'
import { isRecordEmpty } from '../../../../../lib/utils'
import { extractSelectedCollectionFilters } from '../../../../../lib/utils/collection-filters'

export function useFilterAugmentedMetadata({
  handle,
  title,
}: {
  handle: string | undefined
  title: string | undefined
}) {
  const { query } = useRouter()

  const collectionFiltersQueryParam = query[FILTERS_QUERY_PARAM]
  const legacyColorQueryParam = query[LegacyFilterQueryParam.Color]
  const legacyFitQueryParam = query[LegacyFilterQueryParam.Fit]

  const selectedFilters: Record<string, string[]> = useMemo(() => {
    return extractSelectedCollectionFilters({
      collectionFiltersQueryParam,
      legacyCategoryQueryParam: undefined,
      legacyColorQueryParam,
      legacyFitQueryParam,
    })
  }, [collectionFiltersQueryParam, legacyColorQueryParam, legacyFitQueryParam])

  const selectedColorFilters: string[] = (selectedFilters['color'] ?? []).slice(0, 1)
  const selectedLengthFilters: string[] = (selectedFilters['length'] ?? []).slice(0, 1)

  const canonicalFilters: Record<string, string[]> = {}
  if (selectedColorFilters.length > 0) {
    canonicalFilters['color'] = selectedColorFilters
  }
  if (selectedLengthFilters.length > 0) {
    canonicalFilters['length'] = selectedLengthFilters
  }

  const filterAugmentedCanonicalUrl = stringifyUrl({
    url: `${canonicalBaseUrls.collections}${handle}`,
    query: {
      filters: isRecordEmpty(canonicalFilters) ? undefined : JSON.stringify(canonicalFilters),
    },
  })

  const textInjection: string = [
    ...selectedColorFilters,
    ...selectedLengthFilters.map(f => capitalize(f)),
  ].join(' ')

  const filterAugmentedTitle: string | undefined =
    title && textInjection
      ? title.replace(/^((?:(?:wo)?men(?:'|’)s)\s)?(.*$)/i, `$1${textInjection} $2`)
      : title

  return {
    filterAugmentedCanonicalUrl,
    filterAugmentedTitle,
  }
}
